var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.as == 'button')?_c('button',{staticClass:"w-full text-left",class:_vm.classes},[_vm._t("default")],2):_c('Link',{class:_vm.classes,attrs:{"href":_vm.href}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }